export const latinAmericaCountries = [
  // North America
  'MX', // Mexico

  // Central America
  'BZ', // Belize
  'CR', // Costa Rica
  'SV', // El Salvador
  'GT', // Guatemala
  'HN', // Honduras
  'NI', // Nicaragua
  'PA', // Panama

  // Caribbean
  'AG', // Antigua and Barbuda
  'BS', // Bahamas
  'BB', // Barbados
  'CU', // Cuba
  'DM', // Dominica
  'DO', // Dominican Republic
  'GD', // Grenada
  'HT', // Haiti
  'JM', // Jamaica
  'KN', // Saint Kitts and Nevis
  'LC', // Saint Lucia
  'MF', // Saint Martin
  'PR', // Puerto Rico
  'VC', // Saint Vincent and the Grenadines
  'TT', // Trinidad and Tobago

  // South America
  'AR', // Argentina
  'BO', // Bolivia
  'BR', // Brazil
  'CL', // Chile
  'CO', // Colombia
  'EC', // Ecuador
  'GY', // Guyana
  'PY', // Paraguay
  'PE', // Peru
  'SR', // Suriname
  'UY', // Uruguay
  'VE', // Venezuela
]

export const subSaharanAfricaCountryCodes = [
  'AO', // Angola
  'BJ', // Benin
  'BW', // Botswana
  'BF', // Burkina Faso
  'BI', // Burundi
  'CM', // Cameroon
  'CV', // Cabo Verde
  'CF', // Central African Republic
  'TD', // Chad
  'KM', // Comoros
  'CG', // Congo
  'CI', // Côte d'Ivoire
  'CD', // Democratic Republic of the Congo
  'DJ', // Djibouti
  'GQ', // Equatorial Guinea
  'ER', // Eritrea
  'ET', // Ethiopia
  'GA', // Gabon
  'GM', // Gambia
  'GH', // Ghana
  'GN', // Guinea
  'GW', // Guinea-Bissau
  'KE', // Kenya
  'LS', // Lesotho
  'LR', // Liberia
  'MG', // Madagascar
  'MW', // Malawi
  'ML', // Mali
  'MR', // Mauritania
  'MU', // Mauritius
  'MZ', // Mozambique
  'NA', // Namibia
  'NE', // Niger
  'NG', // Nigeria
  'RE', // Réunion
  'RW', // Rwanda
  'ST', // São Tomé and Príncipe
  'SN', // Senegal
  'SC', // Seychelles
  'SL', // Sierra Leone
  'SO', // Somalia
  'SS', // South Sudan
  'SZ', // Eswatini
  'TZ', // Tanzania
  'TG', // Togo
  'UG', // Uganda
  'ZA', // South Africa
  'ZM', // Zambia
  'ZW', // Zimbabwe
]

export const europeCountries = [
  'AD',
  'AM',
  'AT',
  'AZ',
  'BA',
  'BE',
  'BG',
  'BY',
  'CH',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GE',
  'GL',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LT',
  'LU',
  'LV',
  'MC',
  'MD',
  'ME',
  'MK',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'RS',
  'SE',
  'SI',
  'SK',
  'TR',
  'UA',
  'UK',
]

export const northAmericaCountries = ['CA', 'US']

export const chineseCountries = [
  'CN', // (Mainland) China
  'HK', // Hong Kong
  'MO', // Macau
  'SG', // Singapore
  'TW', // Taiwan
]

export const arabicCountryCodes = [
  'AE', // United Arab Emirates
  'BH', // Bahrain
  'DZ', // Algeria
  'EG', // Egypt
  'IL', // Israel
  'IQ', // Iraq
  'JO', // Jordan
  'KW', // Kuwait
  'LB', // Lebanon
  'LY', // Libya
  'MA', // Morocco
  'OM', // Oman
  'PS', // Palestine
  'QA', // Qatar
  'SA', // Saudi Arabia
  'SD', // Sudan
  'SY', // Syria
  'TN', // Tunisia
  'YE', // Yemen
]
